/*
 * Clear Mind Club — single-copy guard for digital guides.
 *
 * Digital guides are licensed one copy per customer. The quantity selector is
 * already hidden and locked to 1 in Liquid (snippets/quantity-selector.liquid),
 * which covers the product page and the cart. This script is the safety net for
 * the one path Liquid cannot cover: adding the same guide to the cart twice,
 * which Shopify merges into a single line with quantity 2.
 *
 * Matching is by product type, so any future physical product is untouched.
 */
(function () {
  'use strict';

  var SINGLE_COPY_TYPES = ['Digital guide', 'Digital download', 'PDF guide'];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var running = false;

  function isSingleCopy(item) {
    return SINGLE_COPY_TYPES.indexOf(item.product_type) !== -1;
  }

  function getCart() {
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.ok ? res.json() : null;
    });
  }

  function setLineToOne(key) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 1 })
    });
  }

  function enforce(reloadIfCorrected) {
    if (running) return Promise.resolve(false);
    running = true;

    return getCart()
      .then(function (cart) {
        if (!cart || !cart.items) return false;

        var overs = cart.items.filter(function (item) {
          return isSingleCopy(item) && item.quantity > 1;
        });
        if (overs.length === 0) return false;

        return overs
          .reduce(function (chain, item) {
            return chain.then(function () {
              return setLineToOne(item.key);
            });
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .catch(function () {
        return false;
      })
      .then(function (corrected) {
        running = false;
        if (corrected && reloadIfCorrected) {
          window.location.reload();
        }
        return corrected;
      });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* Run once on load, so a cart carried over from a previous visit is corrected. */
  onReady(function () {
    enforce(false);
  });

  /* Watch cart mutations made by the theme (add / change / update) and correct
     immediately afterwards. Wrapping fetch keeps this independent of the
     theme's internal event names, which change between Horizon versions. */
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {
        url = '';
      }

      var isCartWrite = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);

      return nativeFetch.apply(this, arguments).then(function (response) {
        if (isCartWrite && response && response.ok && !running) {
          /* Let the theme finish rendering its own response first. */
          setTimeout(function () {
            enforce(true);
          }, 150);
        }
        return response;
      });
    };
  }
})();
